module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("GoogleMap " + (_vm.componentParams.template))
  }, [(_vm.componentParams.template == "bottom-map") ? _c('bottom-map', {
    attrs: {
      "data": _vm.api_response
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5183456f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/GoogleMap.vue
// module id = 268
// module chunks = 38